import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  dateAndTimeStringFromDate,
  isFRM,
  isKYCApp,
  isMVV,
  LocalizePropType,
  schufaCheck,
  selectUser,
  updateUser,
  withTextLocalizer,
  isIncompleteProfile,
} from 'getaway-data-layer';
import { useHistory } from 'react-router-dom';
import ConsentsView from './ConsentsView';
import { dateFromObjectId, navigateTo } from '../../../../utils';

type Props = {
  localize: LocalizePropType;
};

const ConsentsContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const schufaAgreedAt = user?.actions?.find(
    (action) => action?.name === 'creditWorthinessAgreed'
  )?.created;
  const newsLetterConsentAt = user?.actions?.find(
    (action) => action?.name === 'marketingConsentGiven'
  )?.created;

  const inCompleteProfile = isIncompleteProfile(user);
  let onboardingOnlyProduct = isKYCApp();
  const readOnlyMode =
    !inCompleteProfile &&
    onboardingOnlyProduct &&
    !!(isMVV() ? user?.extraData : true);

  const onClose = () => {
    navigateTo(history, '/settings');
  };

  const onUpdateSchufa = () => {
    dispatch(schufaCheck({}));
  };

  const onUpdateNewsLetter = () => {
    dispatch(
      updateUser({ marketingConsentGiven: !user?.marketingConsentGiven })
    );
  };

  return (
    <ConsentsView
      localize={localize}
      onClose={onClose}
      consentDate={
        user?.created
          ? dateAndTimeStringFromDate(new Date(user.created), localize)
          : null
      }
      schufaAgreed={!!schufaAgreedAt}
      schufaAgreedAt={
        schufaAgreedAt
          ? dateAndTimeStringFromDate(new Date(schufaAgreedAt), localize)
          : ''
      }
      marketingConsentGiven={user?.marketingConsentGiven}
      newsLetterConsentAt={
        user?.marketingConsentGiven
          ? dateAndTimeStringFromDate(new Date(newsLetterConsentAt), localize)
          : ''
      }
      onUpdateSchufa={onUpdateSchufa}
      onUpdateNewsLetter={onUpdateNewsLetter}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default withTextLocalizer(ConsentsContainer);
